// This file is auto-generated by @hey-api/openapi-ts

import {
    type DefaultError,
    type InfiniteData,
    infiniteQueryOptions,
    queryOptions,
    type UseMutationOptions,
} from "@tanstack/react-query";
import type { AxiosError } from "axios";

import { client } from "../client.gen";
import {
    authorizedCallbackRoute,
    createSession,
    createSnapshot,
    deleteSession,
    deleteSnapshot,
    deleteSnapshotAccessLog,
    getAlive,
    getAliveProtected,
    getAssetInfos,
    getCases,
    getDeltaEnsembleRealizationsVectorData,
    getDeltaEnsembleStatisticalVectorData,
    getDeltaEnsembleVectorList,
    getDeltaSurfaceData,
    getDrilledWellboreHeaders,
    getEnsembleDetails,
    getFieldIdentifiers,
    getFieldPerforations,
    getFieldScreens,
    getGridModelsInfo,
    getGridParameter,
    getGridSurface,
    getHistoricalVectorData,
    getInitialFluidContactSurfacesMetadata,
    getInjectionData,
    getInplaceTableDefinitions,
    getLogCurveData,
    getLoggedInUser,
    getMediaSasToken,
    getMisfitSurfaceData,
    getObservedSurfacesMetadata,
    getParametersAndSensitivities,
    getPlannedWellboreHeaders,
    getPlannedWellTrajectories,
    getPolygonsData,
    getPolygonsDirectory,
    getProductionData,
    getPvtTableData,
    getRealizationFlowNetwork,
    getRealizationSurfacesMetadata,
    getRealizationsVectorData,
    getRelpermRealizationData,
    getRelpermTableDefinition,
    getRelpermTableNames,
    getRftObservations,
    getRftRealizationData,
    getRftTableDefinition,
    getSeismicCubeMetaList,
    getSeismicSlices,
    getSession,
    getSessionMetadata,
    getSessionsMetadata,
    getSnapshot,
    getSnapshotAccessLogs,
    getSnapshotsMetadata,
    getStatisticalSurfaceDataHybrid,
    getStatisticalVectorData,
    getStatisticalVectorDataPerSensitivity,
    getSummaryObservations,
    getSurfaceData,
    getUserInfo,
    getUserPhoto,
    getVectorList,
    getVfpTable,
    getVfpTables,
    getWellboreCasings,
    getWellboreCompletions,
    getWellboreLogCurveHeaders,
    getWellborePerforations,
    getWellborePickIdentifiers,
    getWellborePicksForPickIdentifier,
    getWellborePicksInStratColumn,
    getWellboreStratigraphicColumns,
    getWellCompletionsData,
    getWellTrajectories,
    loginRoute,
    type Options,
    postGetAggregatedPerRealizationInplaceTableData,
    postGetAggregatedStatisticalInplaceTableData,
    postGetPolylineIntersection,
    postGetSampleSurfaceInPoints,
    postGetSeismicFence,
    postGetSurfaceIntersection,
    postGetWellTrajectoriesFormationSegments,
    postLogout,
    postRefreshFingerprintsForEnsembles,
    root,
    updateSession,
} from "../sdk.gen";
import type {
    AuthorizedCallbackRouteData_api,
    CreateSessionData_api,
    CreateSessionError_api,
    CreateSessionResponse_api,
    CreateSnapshotData_api,
    CreateSnapshotError_api,
    CreateSnapshotResponse_api,
    DeleteSessionData_api,
    DeleteSessionError_api,
    DeleteSnapshotAccessLogData_api,
    DeleteSnapshotAccessLogError_api,
    DeleteSnapshotData_api,
    DeleteSnapshotError_api,
    GetAliveData_api,
    GetAliveProtectedData_api,
    GetAliveProtectedResponse_api,
    GetAliveResponse_api,
    GetAssetInfosData_api,
    GetAssetInfosResponse_api,
    GetCasesData_api,
    GetCasesError_api,
    GetCasesResponse_api,
    GetDeltaEnsembleRealizationsVectorDataData_api,
    GetDeltaEnsembleRealizationsVectorDataError_api,
    GetDeltaEnsembleRealizationsVectorDataResponse_api,
    GetDeltaEnsembleStatisticalVectorDataData_api,
    GetDeltaEnsembleStatisticalVectorDataError_api,
    GetDeltaEnsembleStatisticalVectorDataResponse_api,
    GetDeltaEnsembleVectorListData_api,
    GetDeltaEnsembleVectorListError_api,
    GetDeltaEnsembleVectorListResponse_api,
    GetDeltaSurfaceDataData_api,
    GetDeltaSurfaceDataError_api,
    GetDeltaSurfaceDataResponse_api,
    GetDrilledWellboreHeadersData_api,
    GetDrilledWellboreHeadersError_api,
    GetDrilledWellboreHeadersResponse_api,
    GetEnsembleDetailsData_api,
    GetEnsembleDetailsError_api,
    GetEnsembleDetailsResponse_api,
    GetFieldIdentifiersData_api,
    GetFieldIdentifiersResponse_api,
    GetFieldPerforationsData_api,
    GetFieldPerforationsError_api,
    GetFieldPerforationsResponse_api,
    GetFieldScreensData_api,
    GetFieldScreensError_api,
    GetFieldScreensResponse_api,
    GetGridModelsInfoData_api,
    GetGridModelsInfoError_api,
    GetGridModelsInfoResponse_api,
    GetGridParameterData_api,
    GetGridParameterError_api,
    GetGridParameterResponse_api,
    GetGridSurfaceData_api,
    GetGridSurfaceError_api,
    GetGridSurfaceResponse_api,
    GetHistoricalVectorDataData_api,
    GetHistoricalVectorDataError_api,
    GetHistoricalVectorDataResponse_api,
    GetInitialFluidContactSurfacesMetadataData_api,
    GetInitialFluidContactSurfacesMetadataError_api,
    GetInitialFluidContactSurfacesMetadataResponse_api,
    GetInjectionDataData_api,
    GetInjectionDataError_api,
    GetInjectionDataResponse_api,
    GetInplaceTableDefinitionsData_api,
    GetInplaceTableDefinitionsError_api,
    GetInplaceTableDefinitionsResponse_api,
    GetLogCurveDataData_api,
    GetLogCurveDataError_api,
    GetLogCurveDataResponse_api,
    GetLoggedInUserData_api,
    GetLoggedInUserError_api,
    GetLoggedInUserResponse_api,
    GetMediaSasTokenData_api,
    GetMediaSasTokenResponse_api,
    GetMisfitSurfaceDataData_api,
    GetMisfitSurfaceDataError_api,
    GetMisfitSurfaceDataResponse_api,
    GetObservedSurfacesMetadataData_api,
    GetObservedSurfacesMetadataError_api,
    GetObservedSurfacesMetadataResponse_api,
    GetParametersAndSensitivitiesData_api,
    GetParametersAndSensitivitiesError_api,
    GetParametersAndSensitivitiesResponse_api,
    GetPlannedWellboreHeadersData_api,
    GetPlannedWellboreHeadersError_api,
    GetPlannedWellboreHeadersResponse_api,
    GetPlannedWellTrajectoriesData_api,
    GetPlannedWellTrajectoriesError_api,
    GetPlannedWellTrajectoriesResponse_api,
    GetPolygonsDataData_api,
    GetPolygonsDataError_api,
    GetPolygonsDataResponse_api,
    GetPolygonsDirectoryData_api,
    GetPolygonsDirectoryError_api,
    GetPolygonsDirectoryResponse_api,
    GetProductionDataData_api,
    GetProductionDataError_api,
    GetProductionDataResponse_api,
    GetPvtTableDataData_api,
    GetPvtTableDataError_api,
    GetPvtTableDataResponse_api,
    GetRealizationFlowNetworkData_api,
    GetRealizationFlowNetworkError_api,
    GetRealizationFlowNetworkResponse_api,
    GetRealizationSurfacesMetadataData_api,
    GetRealizationSurfacesMetadataError_api,
    GetRealizationSurfacesMetadataResponse_api,
    GetRealizationsVectorDataData_api,
    GetRealizationsVectorDataError_api,
    GetRealizationsVectorDataResponse_api,
    GetRelpermRealizationDataData_api,
    GetRelpermRealizationDataError_api,
    GetRelpermRealizationDataResponse_api,
    GetRelpermTableDefinitionData_api,
    GetRelpermTableDefinitionError_api,
    GetRelpermTableDefinitionResponse_api,
    GetRelpermTableNamesData_api,
    GetRelpermTableNamesError_api,
    GetRelpermTableNamesResponse_api,
    GetRftObservationsData_api,
    GetRftObservationsError_api,
    GetRftObservationsResponse_api,
    GetRftRealizationDataData_api,
    GetRftRealizationDataError_api,
    GetRftRealizationDataResponse_api,
    GetRftTableDefinitionData_api,
    GetRftTableDefinitionError_api,
    GetRftTableDefinitionResponse_api,
    GetSeismicCubeMetaListData_api,
    GetSeismicCubeMetaListError_api,
    GetSeismicCubeMetaListResponse_api,
    GetSeismicSlicesData_api,
    GetSeismicSlicesError_api,
    GetSeismicSlicesResponse_api,
    GetSessionData_api,
    GetSessionError_api,
    GetSessionMetadataData_api,
    GetSessionMetadataError_api,
    GetSessionMetadataResponse_api,
    GetSessionResponse_api,
    GetSessionsMetadataData_api,
    GetSessionsMetadataError_api,
    GetSessionsMetadataResponse_api,
    GetSnapshotAccessLogsData_api,
    GetSnapshotAccessLogsError_api,
    GetSnapshotAccessLogsResponse_api,
    GetSnapshotData_api,
    GetSnapshotError_api,
    GetSnapshotResponse_api,
    GetSnapshotsMetadataData_api,
    GetSnapshotsMetadataError_api,
    GetSnapshotsMetadataResponse_api,
    GetStatisticalSurfaceDataHybridData_api,
    GetStatisticalSurfaceDataHybridError_api,
    GetStatisticalSurfaceDataHybridResponse_api,
    GetStatisticalVectorDataData_api,
    GetStatisticalVectorDataError_api,
    GetStatisticalVectorDataPerSensitivityData_api,
    GetStatisticalVectorDataPerSensitivityError_api,
    GetStatisticalVectorDataPerSensitivityResponse_api,
    GetStatisticalVectorDataResponse_api,
    GetSummaryObservationsData_api,
    GetSummaryObservationsError_api,
    GetSummaryObservationsResponse_api,
    GetSurfaceDataData_api,
    GetSurfaceDataError_api,
    GetSurfaceDataResponse_api,
    GetUserInfoData_api,
    GetUserInfoError_api,
    GetUserInfoResponse_api,
    GetUserPhotoData_api,
    GetUserPhotoError_api,
    GetUserPhotoResponse_api,
    GetVectorListData_api,
    GetVectorListError_api,
    GetVectorListResponse_api,
    GetVfpTableData_api,
    GetVfpTableError_api,
    GetVfpTableResponse_api,
    GetVfpTablesData_api,
    GetVfpTablesError_api,
    GetVfpTablesResponse_api,
    GetWellboreCasingsData_api,
    GetWellboreCasingsError_api,
    GetWellboreCasingsResponse_api,
    GetWellboreCompletionsData_api,
    GetWellboreCompletionsError_api,
    GetWellboreCompletionsResponse_api,
    GetWellboreLogCurveHeadersData_api,
    GetWellboreLogCurveHeadersError_api,
    GetWellboreLogCurveHeadersResponse_api,
    GetWellborePerforationsData_api,
    GetWellborePerforationsError_api,
    GetWellborePerforationsResponse_api,
    GetWellborePickIdentifiersData_api,
    GetWellborePickIdentifiersError_api,
    GetWellborePickIdentifiersResponse_api,
    GetWellborePicksForPickIdentifierData_api,
    GetWellborePicksForPickIdentifierError_api,
    GetWellborePicksForPickIdentifierResponse_api,
    GetWellborePicksInStratColumnData_api,
    GetWellborePicksInStratColumnError_api,
    GetWellborePicksInStratColumnResponse_api,
    GetWellboreStratigraphicColumnsData_api,
    GetWellboreStratigraphicColumnsError_api,
    GetWellboreStratigraphicColumnsResponse_api,
    GetWellCompletionsDataData_api,
    GetWellCompletionsDataError_api,
    GetWellCompletionsDataResponse_api,
    GetWellTrajectoriesData_api,
    GetWellTrajectoriesError_api,
    GetWellTrajectoriesResponse_api,
    LoginRouteData_api,
    LoginRouteError_api,
    PostGetAggregatedPerRealizationInplaceTableDataData_api,
    PostGetAggregatedPerRealizationInplaceTableDataError_api,
    PostGetAggregatedPerRealizationInplaceTableDataResponse_api,
    PostGetAggregatedStatisticalInplaceTableDataData_api,
    PostGetAggregatedStatisticalInplaceTableDataError_api,
    PostGetAggregatedStatisticalInplaceTableDataResponse_api,
    PostGetPolylineIntersectionData_api,
    PostGetPolylineIntersectionError_api,
    PostGetPolylineIntersectionResponse_api,
    PostGetSampleSurfaceInPointsData_api,
    PostGetSampleSurfaceInPointsError_api,
    PostGetSampleSurfaceInPointsResponse_api,
    PostGetSeismicFenceData_api,
    PostGetSeismicFenceError_api,
    PostGetSeismicFenceResponse_api,
    PostGetSurfaceIntersectionData_api,
    PostGetSurfaceIntersectionError_api,
    PostGetSurfaceIntersectionResponse_api,
    PostGetWellTrajectoriesFormationSegmentsData_api,
    PostGetWellTrajectoriesFormationSegmentsError_api,
    PostGetWellTrajectoriesFormationSegmentsResponse_api,
    PostLogoutData_api,
    PostLogoutResponse_api,
    PostRefreshFingerprintsForEnsemblesData_api,
    PostRefreshFingerprintsForEnsemblesError_api,
    PostRefreshFingerprintsForEnsemblesResponse_api,
    RootData_api,
    RootResponse_api,
    UpdateSessionData_api,
    UpdateSessionError_api,
    UpdateSessionResponse_api,
} from "../types.gen";

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, "baseURL" | "body" | "headers" | "path" | "query"> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    },
];

const createQueryKey = <TOptions extends Options>(
    id: string,
    options?: TOptions,
    infinite?: boolean,
    tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
    const params: QueryKey<TOptions>[0] = {
        _id: id,
        baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL,
    } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getAssetInfosQueryKey = (options?: Options<GetAssetInfosData_api>) =>
    createQueryKey("getAssetInfos", options);

/**
 * Get Asset Infos
 *
 * Get list of asset infos
 */
export const getAssetInfosOptions = (options?: Options<GetAssetInfosData_api>) =>
    queryOptions<
        GetAssetInfosResponse_api,
        AxiosError<DefaultError>,
        GetAssetInfosResponse_api,
        ReturnType<typeof getAssetInfosQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAssetInfos({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getAssetInfosQueryKey(options),
    });

export const getFieldIdentifiersQueryKey = (options?: Options<GetFieldIdentifiersData_api>) =>
    createQueryKey("getFieldIdentifiers", options);

/**
 * Get Field Identifiers
 *
 * Get list of field identifiers
 */
export const getFieldIdentifiersOptions = (options?: Options<GetFieldIdentifiersData_api>) =>
    queryOptions<
        GetFieldIdentifiersResponse_api,
        AxiosError<DefaultError>,
        GetFieldIdentifiersResponse_api,
        ReturnType<typeof getFieldIdentifiersQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldIdentifiers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFieldIdentifiersQueryKey(options),
    });

export const getCasesQueryKey = (options: Options<GetCasesData_api>) => createQueryKey("getCases", options);

/**
 * Get Cases
 *
 * Get list of cases for specified asset
 */
export const getCasesOptions = (options: Options<GetCasesData_api>) =>
    queryOptions<
        GetCasesResponse_api,
        AxiosError<GetCasesError_api>,
        GetCasesResponse_api,
        ReturnType<typeof getCasesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCases({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getCasesQueryKey(options),
    });

export const getEnsembleDetailsQueryKey = (options: Options<GetEnsembleDetailsData_api>) =>
    createQueryKey("getEnsembleDetails", options);

/**
 * Get Ensemble Details
 *
 * Get more detailed information for an ensemble
 */
export const getEnsembleDetailsOptions = (options: Options<GetEnsembleDetailsData_api>) =>
    queryOptions<
        GetEnsembleDetailsResponse_api,
        AxiosError<GetEnsembleDetailsError_api>,
        GetEnsembleDetailsResponse_api,
        ReturnType<typeof getEnsembleDetailsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getEnsembleDetails({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getEnsembleDetailsQueryKey(options),
    });

export const postRefreshFingerprintsForEnsemblesQueryKey = (
    options: Options<PostRefreshFingerprintsForEnsemblesData_api>,
) => createQueryKey("postRefreshFingerprintsForEnsembles", options);

/**
 * Post Refresh Fingerprints For Ensembles
 *
 * Retrieves freshly calculated fingerprints for a list of ensembles
 */
export const postRefreshFingerprintsForEnsemblesOptions = (
    options: Options<PostRefreshFingerprintsForEnsemblesData_api>,
) =>
    queryOptions<
        PostRefreshFingerprintsForEnsemblesResponse_api,
        AxiosError<PostRefreshFingerprintsForEnsemblesError_api>,
        PostRefreshFingerprintsForEnsemblesResponse_api,
        ReturnType<typeof postRefreshFingerprintsForEnsemblesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postRefreshFingerprintsForEnsembles({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: postRefreshFingerprintsForEnsemblesQueryKey(options),
    });

/**
 * Post Refresh Fingerprints For Ensembles
 *
 * Retrieves freshly calculated fingerprints for a list of ensembles
 */
export const postRefreshFingerprintsForEnsemblesMutation = (
    options?: Partial<Options<PostRefreshFingerprintsForEnsemblesData_api>>,
): UseMutationOptions<
    PostRefreshFingerprintsForEnsemblesResponse_api,
    AxiosError<PostRefreshFingerprintsForEnsemblesError_api>,
    Options<PostRefreshFingerprintsForEnsemblesData_api>
> => {
    const mutationOptions: UseMutationOptions<
        PostRefreshFingerprintsForEnsemblesResponse_api,
        AxiosError<PostRefreshFingerprintsForEnsemblesError_api>,
        Options<PostRefreshFingerprintsForEnsemblesData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postRefreshFingerprintsForEnsembles({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getVectorListQueryKey = (options: Options<GetVectorListData_api>) =>
    createQueryKey("getVectorList", options);

/**
 * Get Vector List
 *
 * Get list of all vectors in a given Sumo ensemble, excluding any historical vectors
 *
 * Optionally include derived vectors.
 */
export const getVectorListOptions = (options: Options<GetVectorListData_api>) =>
    queryOptions<
        GetVectorListResponse_api,
        AxiosError<GetVectorListError_api>,
        GetVectorListResponse_api,
        ReturnType<typeof getVectorListQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getVectorList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getVectorListQueryKey(options),
    });

export const getDeltaEnsembleVectorListQueryKey = (options: Options<GetDeltaEnsembleVectorListData_api>) =>
    createQueryKey("getDeltaEnsembleVectorList", options);

/**
 * Get Delta Ensemble Vector List
 *
 * Get list of all vectors for a delta ensemble based on all vectors in a given Sumo ensemble, excluding any historical vectors
 *
 * Definition:
 *
 * delta_ensemble = comparison_ensemble - reference_ensemble
 */
export const getDeltaEnsembleVectorListOptions = (options: Options<GetDeltaEnsembleVectorListData_api>) =>
    queryOptions<
        GetDeltaEnsembleVectorListResponse_api,
        AxiosError<GetDeltaEnsembleVectorListError_api>,
        GetDeltaEnsembleVectorListResponse_api,
        ReturnType<typeof getDeltaEnsembleVectorListQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDeltaEnsembleVectorList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getDeltaEnsembleVectorListQueryKey(options),
    });

export const getRealizationsVectorDataQueryKey = (options: Options<GetRealizationsVectorDataData_api>) =>
    createQueryKey("getRealizationsVectorData", options);

/**
 * Get Realizations Vector Data
 *
 * Get vector data per realization
 */
export const getRealizationsVectorDataOptions = (options: Options<GetRealizationsVectorDataData_api>) =>
    queryOptions<
        GetRealizationsVectorDataResponse_api,
        AxiosError<GetRealizationsVectorDataError_api>,
        GetRealizationsVectorDataResponse_api,
        ReturnType<typeof getRealizationsVectorDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRealizationsVectorData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRealizationsVectorDataQueryKey(options),
    });

export const getDeltaEnsembleRealizationsVectorDataQueryKey = (
    options: Options<GetDeltaEnsembleRealizationsVectorDataData_api>,
) => createQueryKey("getDeltaEnsembleRealizationsVectorData", options);

/**
 * Get Delta Ensemble Realizations Vector Data
 *
 * Get vector data per realization
 *
 * Definition:
 *
 * delta_ensemble = comparison_ensemble - reference_ensemble
 */
export const getDeltaEnsembleRealizationsVectorDataOptions = (
    options: Options<GetDeltaEnsembleRealizationsVectorDataData_api>,
) =>
    queryOptions<
        GetDeltaEnsembleRealizationsVectorDataResponse_api,
        AxiosError<GetDeltaEnsembleRealizationsVectorDataError_api>,
        GetDeltaEnsembleRealizationsVectorDataResponse_api,
        ReturnType<typeof getDeltaEnsembleRealizationsVectorDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDeltaEnsembleRealizationsVectorData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getDeltaEnsembleRealizationsVectorDataQueryKey(options),
    });

export const getHistoricalVectorDataQueryKey = (options: Options<GetHistoricalVectorDataData_api>) =>
    createQueryKey("getHistoricalVectorData", options);

/**
 * Get Historical Vector Data
 */
export const getHistoricalVectorDataOptions = (options: Options<GetHistoricalVectorDataData_api>) =>
    queryOptions<
        GetHistoricalVectorDataResponse_api,
        AxiosError<GetHistoricalVectorDataError_api>,
        GetHistoricalVectorDataResponse_api,
        ReturnType<typeof getHistoricalVectorDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getHistoricalVectorData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getHistoricalVectorDataQueryKey(options),
    });

export const getStatisticalVectorDataQueryKey = (options: Options<GetStatisticalVectorDataData_api>) =>
    createQueryKey("getStatisticalVectorData", options);

/**
 * Get Statistical Vector Data
 *
 * Get statistical vector data for an ensemble
 */
export const getStatisticalVectorDataOptions = (options: Options<GetStatisticalVectorDataData_api>) =>
    queryOptions<
        GetStatisticalVectorDataResponse_api,
        AxiosError<GetStatisticalVectorDataError_api>,
        GetStatisticalVectorDataResponse_api,
        ReturnType<typeof getStatisticalVectorDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStatisticalVectorData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getStatisticalVectorDataQueryKey(options),
    });

export const getDeltaEnsembleStatisticalVectorDataQueryKey = (
    options: Options<GetDeltaEnsembleStatisticalVectorDataData_api>,
) => createQueryKey("getDeltaEnsembleStatisticalVectorData", options);

/**
 * Get Delta Ensemble Statistical Vector Data
 *
 * Get statistical vector data for an ensemble
 *
 * Definition:
 *
 * delta_ensemble = comparison_ensemble - reference_ensemble
 */
export const getDeltaEnsembleStatisticalVectorDataOptions = (
    options: Options<GetDeltaEnsembleStatisticalVectorDataData_api>,
) =>
    queryOptions<
        GetDeltaEnsembleStatisticalVectorDataResponse_api,
        AxiosError<GetDeltaEnsembleStatisticalVectorDataError_api>,
        GetDeltaEnsembleStatisticalVectorDataResponse_api,
        ReturnType<typeof getDeltaEnsembleStatisticalVectorDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDeltaEnsembleStatisticalVectorData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getDeltaEnsembleStatisticalVectorDataQueryKey(options),
    });

export const getStatisticalVectorDataPerSensitivityQueryKey = (
    options: Options<GetStatisticalVectorDataPerSensitivityData_api>,
) => createQueryKey("getStatisticalVectorDataPerSensitivity", options);

/**
 * Get Statistical Vector Data Per Sensitivity
 *
 * Get statistical vector data for an ensemble per sensitivity
 */
export const getStatisticalVectorDataPerSensitivityOptions = (
    options: Options<GetStatisticalVectorDataPerSensitivityData_api>,
) =>
    queryOptions<
        GetStatisticalVectorDataPerSensitivityResponse_api,
        AxiosError<GetStatisticalVectorDataPerSensitivityError_api>,
        GetStatisticalVectorDataPerSensitivityResponse_api,
        ReturnType<typeof getStatisticalVectorDataPerSensitivityQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStatisticalVectorDataPerSensitivity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getStatisticalVectorDataPerSensitivityQueryKey(options),
    });

export const getInplaceTableDefinitionsQueryKey = (options: Options<GetInplaceTableDefinitionsData_api>) =>
    createQueryKey("getInplaceTableDefinitions", options);

/**
 * Get Inplace Table Definitions
 *
 * Get the inplace volumes tables definitions for a given ensemble.
 */
export const getInplaceTableDefinitionsOptions = (options: Options<GetInplaceTableDefinitionsData_api>) =>
    queryOptions<
        GetInplaceTableDefinitionsResponse_api,
        AxiosError<GetInplaceTableDefinitionsError_api>,
        GetInplaceTableDefinitionsResponse_api,
        ReturnType<typeof getInplaceTableDefinitionsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInplaceTableDefinitions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getInplaceTableDefinitionsQueryKey(options),
    });

export const postGetAggregatedPerRealizationInplaceTableDataQueryKey = (
    options: Options<PostGetAggregatedPerRealizationInplaceTableDataData_api>,
) => createQueryKey("postGetAggregatedPerRealizationInplaceTableData", options);

/**
 * Post Get Aggregated Per Realization Inplace Table Data
 *
 * Get aggregated inplace volume data for a given table with data per realization based on requested results and categories/index filter.
 *
 * Note: This endpoint is a post endpoint because the list of indices with values can be quite large and may exceed the query string limit.
 * As the endpoint is post, the indices with values object is kept for convenience.
 */
export const postGetAggregatedPerRealizationInplaceTableDataOptions = (
    options: Options<PostGetAggregatedPerRealizationInplaceTableDataData_api>,
) =>
    queryOptions<
        PostGetAggregatedPerRealizationInplaceTableDataResponse_api,
        AxiosError<PostGetAggregatedPerRealizationInplaceTableDataError_api>,
        PostGetAggregatedPerRealizationInplaceTableDataResponse_api,
        ReturnType<typeof postGetAggregatedPerRealizationInplaceTableDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postGetAggregatedPerRealizationInplaceTableData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: postGetAggregatedPerRealizationInplaceTableDataQueryKey(options),
    });

/**
 * Post Get Aggregated Per Realization Inplace Table Data
 *
 * Get aggregated inplace volume data for a given table with data per realization based on requested results and categories/index filter.
 *
 * Note: This endpoint is a post endpoint because the list of indices with values can be quite large and may exceed the query string limit.
 * As the endpoint is post, the indices with values object is kept for convenience.
 */
export const postGetAggregatedPerRealizationInplaceTableDataMutation = (
    options?: Partial<Options<PostGetAggregatedPerRealizationInplaceTableDataData_api>>,
): UseMutationOptions<
    PostGetAggregatedPerRealizationInplaceTableDataResponse_api,
    AxiosError<PostGetAggregatedPerRealizationInplaceTableDataError_api>,
    Options<PostGetAggregatedPerRealizationInplaceTableDataData_api>
> => {
    const mutationOptions: UseMutationOptions<
        PostGetAggregatedPerRealizationInplaceTableDataResponse_api,
        AxiosError<PostGetAggregatedPerRealizationInplaceTableDataError_api>,
        Options<PostGetAggregatedPerRealizationInplaceTableDataData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postGetAggregatedPerRealizationInplaceTableData({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const postGetAggregatedStatisticalInplaceTableDataQueryKey = (
    options: Options<PostGetAggregatedStatisticalInplaceTableDataData_api>,
) => createQueryKey("postGetAggregatedStatisticalInplaceTableData", options);

/**
 * Post Get Aggregated Statistical Inplace Table Data
 *
 * Get statistical inplace volumes data across selected realizations for a given table based on requested results and categories/index filter.
 *
 * Note: This endpoint is a post endpoint because the list of indices with values can be quite large and may exceed the query string limit.
 * As the endpoint is post, the indices with values object is kept for convenience.
 */
export const postGetAggregatedStatisticalInplaceTableDataOptions = (
    options: Options<PostGetAggregatedStatisticalInplaceTableDataData_api>,
) =>
    queryOptions<
        PostGetAggregatedStatisticalInplaceTableDataResponse_api,
        AxiosError<PostGetAggregatedStatisticalInplaceTableDataError_api>,
        PostGetAggregatedStatisticalInplaceTableDataResponse_api,
        ReturnType<typeof postGetAggregatedStatisticalInplaceTableDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postGetAggregatedStatisticalInplaceTableData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: postGetAggregatedStatisticalInplaceTableDataQueryKey(options),
    });

/**
 * Post Get Aggregated Statistical Inplace Table Data
 *
 * Get statistical inplace volumes data across selected realizations for a given table based on requested results and categories/index filter.
 *
 * Note: This endpoint is a post endpoint because the list of indices with values can be quite large and may exceed the query string limit.
 * As the endpoint is post, the indices with values object is kept for convenience.
 */
export const postGetAggregatedStatisticalInplaceTableDataMutation = (
    options?: Partial<Options<PostGetAggregatedStatisticalInplaceTableDataData_api>>,
): UseMutationOptions<
    PostGetAggregatedStatisticalInplaceTableDataResponse_api,
    AxiosError<PostGetAggregatedStatisticalInplaceTableDataError_api>,
    Options<PostGetAggregatedStatisticalInplaceTableDataData_api>
> => {
    const mutationOptions: UseMutationOptions<
        PostGetAggregatedStatisticalInplaceTableDataResponse_api,
        AxiosError<PostGetAggregatedStatisticalInplaceTableDataError_api>,
        Options<PostGetAggregatedStatisticalInplaceTableDataData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postGetAggregatedStatisticalInplaceTableData({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getRealizationSurfacesMetadataQueryKey = (options: Options<GetRealizationSurfacesMetadataData_api>) =>
    createQueryKey("getRealizationSurfacesMetadata", options);

/**
 * Get Realization Surfaces Metadata
 *
 * Get metadata for realization surfaces in a Sumo ensemble
 */
export const getRealizationSurfacesMetadataOptions = (options: Options<GetRealizationSurfacesMetadataData_api>) =>
    queryOptions<
        GetRealizationSurfacesMetadataResponse_api,
        AxiosError<GetRealizationSurfacesMetadataError_api>,
        GetRealizationSurfacesMetadataResponse_api,
        ReturnType<typeof getRealizationSurfacesMetadataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRealizationSurfacesMetadata({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRealizationSurfacesMetadataQueryKey(options),
    });

export const getObservedSurfacesMetadataQueryKey = (options: Options<GetObservedSurfacesMetadataData_api>) =>
    createQueryKey("getObservedSurfacesMetadata", options);

/**
 * Get Observed Surfaces Metadata
 *
 * Get metadata for observed surfaces in a Sumo case
 */
export const getObservedSurfacesMetadataOptions = (options: Options<GetObservedSurfacesMetadataData_api>) =>
    queryOptions<
        GetObservedSurfacesMetadataResponse_api,
        AxiosError<GetObservedSurfacesMetadataError_api>,
        GetObservedSurfacesMetadataResponse_api,
        ReturnType<typeof getObservedSurfacesMetadataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getObservedSurfacesMetadata({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getObservedSurfacesMetadataQueryKey(options),
    });

export const getInitialFluidContactSurfacesMetadataQueryKey = (
    options: Options<GetInitialFluidContactSurfacesMetadataData_api>,
) => createQueryKey("getInitialFluidContactSurfacesMetadata", options);

/**
 * Get Initial Fluid Contact Surfaces Metadata
 *
 * Get metadata for the initial fluid contact surfaces in a Sumo ensemble
 */
export const getInitialFluidContactSurfacesMetadataOptions = (
    options: Options<GetInitialFluidContactSurfacesMetadataData_api>,
) =>
    queryOptions<
        GetInitialFluidContactSurfacesMetadataResponse_api,
        AxiosError<GetInitialFluidContactSurfacesMetadataError_api>,
        GetInitialFluidContactSurfacesMetadataResponse_api,
        ReturnType<typeof getInitialFluidContactSurfacesMetadataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInitialFluidContactSurfacesMetadata({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getInitialFluidContactSurfacesMetadataQueryKey(options),
    });

export const getSurfaceDataQueryKey = (options: Options<GetSurfaceDataData_api>) =>
    createQueryKey("getSurfaceData", options);

/**
 * Get Surface Data
 *
 * Get surface data for the specified surface.
 *
 * ---
 * *General description of the types of surface addresses that exist. The specific address types supported by this endpoint can be a subset of these.*
 *
 * - *REAL* - Realization surface address. Addresses a specific realization surface within an ensemble. Always specifies a single realization number
 * - *OBS* - Observed surface address. Addresses an observed surface which is not associated with any specific ensemble.
 * - *STAT* - Statistical surface address. Fully specifies a statistical surface, including the statistic function and which realizations to include.
 *
 * Structure of the different types of address strings:
 *
 * ```
 * REAL~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<realization>[~~<iso_date_or_interval>]
 * STAT~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<stat_function>~~<stat_realizations>[~~<iso_date_or_interval>]
 * OBS~~<case_uuid>~~<surface_name>~~<attribute>~~<iso_date_or_interval>
 * ```
 *
 * The `<attribute>` component always spans three sub-components and says how the surface is identified:
 *
 * ```
 * TAGNAME~~<tagname>~~-
 * STDRES~~<standard_result>~~<sub_name>
 * ```
 *
 * A *TAGNAME* attribute matches the free text tagname the surface was exported with. A *STDRES* attribute matches an
 * FMU standard result, where `<sub_name>` discriminates between surfaces within that standard result, for example the
 * contact type for `fluid_contact_surface`. Unused components are set to "-".
 *
 * The `<stat_realizations>` component in a *STAT* address contains the list of realizations to include in the statistics
 * encoded as a `UintListStr` or "*" to include all realizations.
 */
export const getSurfaceDataOptions = (options: Options<GetSurfaceDataData_api>) =>
    queryOptions<
        GetSurfaceDataResponse_api,
        AxiosError<GetSurfaceDataError_api>,
        GetSurfaceDataResponse_api,
        ReturnType<typeof getSurfaceDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSurfaceData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSurfaceDataQueryKey(options),
    });

export const postGetWellTrajectoriesFormationSegmentsQueryKey = (
    options: Options<PostGetWellTrajectoriesFormationSegmentsData_api>,
) => createQueryKey("postGetWellTrajectoriesFormationSegments", options);

/**
 * Post Get Well Trajectories Formation Segments
 *
 * Get well trajectory formation segments.
 *
 * Provide a top bounding depth surface and an optional bottom bounding depth surface to define a
 * formation (area between two surfaces in depth). If bottom surface is not provided, the formation
 * is considered to extend down to the end of the well trajectory, i.e. end of well trajectory is
 * used as lower bound for formation.
 *
 * For each well trajectory, the segments where the well is within the formation are calculated and
 * returned. Each segment contains the measured depth (md) values where the well enters and exits
 * the formation.
 *
 * NOTE: Expecting depth surfaces, no verification is done to ensure that the surfaces are indeed
 * depth surfaces.
 */
export const postGetWellTrajectoriesFormationSegmentsOptions = (
    options: Options<PostGetWellTrajectoriesFormationSegmentsData_api>,
) =>
    queryOptions<
        PostGetWellTrajectoriesFormationSegmentsResponse_api,
        AxiosError<PostGetWellTrajectoriesFormationSegmentsError_api>,
        PostGetWellTrajectoriesFormationSegmentsResponse_api,
        ReturnType<typeof postGetWellTrajectoriesFormationSegmentsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postGetWellTrajectoriesFormationSegments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: postGetWellTrajectoriesFormationSegmentsQueryKey(options),
    });

/**
 * Post Get Well Trajectories Formation Segments
 *
 * Get well trajectory formation segments.
 *
 * Provide a top bounding depth surface and an optional bottom bounding depth surface to define a
 * formation (area between two surfaces in depth). If bottom surface is not provided, the formation
 * is considered to extend down to the end of the well trajectory, i.e. end of well trajectory is
 * used as lower bound for formation.
 *
 * For each well trajectory, the segments where the well is within the formation are calculated and
 * returned. Each segment contains the measured depth (md) values where the well enters and exits
 * the formation.
 *
 * NOTE: Expecting depth surfaces, no verification is done to ensure that the surfaces are indeed
 * depth surfaces.
 */
export const postGetWellTrajectoriesFormationSegmentsMutation = (
    options?: Partial<Options<PostGetWellTrajectoriesFormationSegmentsData_api>>,
): UseMutationOptions<
    PostGetWellTrajectoriesFormationSegmentsResponse_api,
    AxiosError<PostGetWellTrajectoriesFormationSegmentsError_api>,
    Options<PostGetWellTrajectoriesFormationSegmentsData_api>
> => {
    const mutationOptions: UseMutationOptions<
        PostGetWellTrajectoriesFormationSegmentsResponse_api,
        AxiosError<PostGetWellTrajectoriesFormationSegmentsError_api>,
        Options<PostGetWellTrajectoriesFormationSegmentsData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postGetWellTrajectoriesFormationSegments({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getStatisticalSurfaceDataHybridQueryKey = (options: Options<GetStatisticalSurfaceDataHybridData_api>) =>
    createQueryKey("getStatisticalSurfaceDataHybrid", options);

/**
 * Get Statistical Surface Data Hybrid
 */
export const getStatisticalSurfaceDataHybridOptions = (options: Options<GetStatisticalSurfaceDataHybridData_api>) =>
    queryOptions<
        GetStatisticalSurfaceDataHybridResponse_api,
        AxiosError<GetStatisticalSurfaceDataHybridError_api>,
        GetStatisticalSurfaceDataHybridResponse_api,
        ReturnType<typeof getStatisticalSurfaceDataHybridQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStatisticalSurfaceDataHybrid({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getStatisticalSurfaceDataHybridQueryKey(options),
    });

export const postGetSurfaceIntersectionQueryKey = (options: Options<PostGetSurfaceIntersectionData_api>) =>
    createQueryKey("postGetSurfaceIntersection", options);

/**
 * Post Get Surface Intersection
 *
 * Get surface intersection data for the specified surface.
 *
 * ---
 * *General description of the types of surface addresses that exist. The specific address types supported by this endpoint can be a subset of these.*
 *
 * - *REAL* - Realization surface address. Addresses a specific realization surface within an ensemble. Always specifies a single realization number
 * - *OBS* - Observed surface address. Addresses an observed surface which is not associated with any specific ensemble.
 * - *STAT* - Statistical surface address. Fully specifies a statistical surface, including the statistic function and which realizations to include.
 *
 * Structure of the different types of address strings:
 *
 * ```
 * REAL~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<realization>[~~<iso_date_or_interval>]
 * STAT~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<stat_function>~~<stat_realizations>[~~<iso_date_or_interval>]
 * OBS~~<case_uuid>~~<surface_name>~~<attribute>~~<iso_date_or_interval>
 * ```
 *
 * The `<attribute>` component always spans three sub-components and says how the surface is identified:
 *
 * ```
 * TAGNAME~~<tagname>~~-
 * STDRES~~<standard_result>~~<sub_name>
 * ```
 *
 * A *TAGNAME* attribute matches the free text tagname the surface was exported with. A *STDRES* attribute matches an
 * FMU standard result, where `<sub_name>` discriminates between surfaces within that standard result, for example the
 * contact type for `fluid_contact_surface`. Unused components are set to "-".
 *
 * The `<stat_realizations>` component in a *STAT* address contains the list of realizations to include in the statistics
 * encoded as a `UintListStr` or "*" to include all realizations.
 */
export const postGetSurfaceIntersectionOptions = (options: Options<PostGetSurfaceIntersectionData_api>) =>
    queryOptions<
        PostGetSurfaceIntersectionResponse_api,
        AxiosError<PostGetSurfaceIntersectionError_api>,
        PostGetSurfaceIntersectionResponse_api,
        ReturnType<typeof postGetSurfaceIntersectionQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postGetSurfaceIntersection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: postGetSurfaceIntersectionQueryKey(options),
    });

/**
 * Post Get Surface Intersection
 *
 * Get surface intersection data for the specified surface.
 *
 * ---
 * *General description of the types of surface addresses that exist. The specific address types supported by this endpoint can be a subset of these.*
 *
 * - *REAL* - Realization surface address. Addresses a specific realization surface within an ensemble. Always specifies a single realization number
 * - *OBS* - Observed surface address. Addresses an observed surface which is not associated with any specific ensemble.
 * - *STAT* - Statistical surface address. Fully specifies a statistical surface, including the statistic function and which realizations to include.
 *
 * Structure of the different types of address strings:
 *
 * ```
 * REAL~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<realization>[~~<iso_date_or_interval>]
 * STAT~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<stat_function>~~<stat_realizations>[~~<iso_date_or_interval>]
 * OBS~~<case_uuid>~~<surface_name>~~<attribute>~~<iso_date_or_interval>
 * ```
 *
 * The `<attribute>` component always spans three sub-components and says how the surface is identified:
 *
 * ```
 * TAGNAME~~<tagname>~~-
 * STDRES~~<standard_result>~~<sub_name>
 * ```
 *
 * A *TAGNAME* attribute matches the free text tagname the surface was exported with. A *STDRES* attribute matches an
 * FMU standard result, where `<sub_name>` discriminates between surfaces within that standard result, for example the
 * contact type for `fluid_contact_surface`. Unused components are set to "-".
 *
 * The `<stat_realizations>` component in a *STAT* address contains the list of realizations to include in the statistics
 * encoded as a `UintListStr` or "*" to include all realizations.
 */
export const postGetSurfaceIntersectionMutation = (
    options?: Partial<Options<PostGetSurfaceIntersectionData_api>>,
): UseMutationOptions<
    PostGetSurfaceIntersectionResponse_api,
    AxiosError<PostGetSurfaceIntersectionError_api>,
    Options<PostGetSurfaceIntersectionData_api>
> => {
    const mutationOptions: UseMutationOptions<
        PostGetSurfaceIntersectionResponse_api,
        AxiosError<PostGetSurfaceIntersectionError_api>,
        Options<PostGetSurfaceIntersectionData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postGetSurfaceIntersection({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const postGetSampleSurfaceInPointsQueryKey = (options: Options<PostGetSampleSurfaceInPointsData_api>) =>
    createQueryKey("postGetSampleSurfaceInPoints", options);

/**
 * Post Get Sample Surface In Points
 */
export const postGetSampleSurfaceInPointsOptions = (options: Options<PostGetSampleSurfaceInPointsData_api>) =>
    queryOptions<
        PostGetSampleSurfaceInPointsResponse_api,
        AxiosError<PostGetSampleSurfaceInPointsError_api>,
        PostGetSampleSurfaceInPointsResponse_api,
        ReturnType<typeof postGetSampleSurfaceInPointsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postGetSampleSurfaceInPoints({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: postGetSampleSurfaceInPointsQueryKey(options),
    });

/**
 * Post Get Sample Surface In Points
 */
export const postGetSampleSurfaceInPointsMutation = (
    options?: Partial<Options<PostGetSampleSurfaceInPointsData_api>>,
): UseMutationOptions<
    PostGetSampleSurfaceInPointsResponse_api,
    AxiosError<PostGetSampleSurfaceInPointsError_api>,
    Options<PostGetSampleSurfaceInPointsData_api>
> => {
    const mutationOptions: UseMutationOptions<
        PostGetSampleSurfaceInPointsResponse_api,
        AxiosError<PostGetSampleSurfaceInPointsError_api>,
        Options<PostGetSampleSurfaceInPointsData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postGetSampleSurfaceInPoints({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getDeltaSurfaceDataQueryKey = (options: Options<GetDeltaSurfaceDataData_api>) =>
    createQueryKey("getDeltaSurfaceData", options);

/**
 * Get Delta Surface Data
 */
export const getDeltaSurfaceDataOptions = (options: Options<GetDeltaSurfaceDataData_api>) =>
    queryOptions<
        GetDeltaSurfaceDataResponse_api,
        AxiosError<GetDeltaSurfaceDataError_api>,
        GetDeltaSurfaceDataResponse_api,
        ReturnType<typeof getDeltaSurfaceDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDeltaSurfaceData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getDeltaSurfaceDataQueryKey(options),
    });

export const getMisfitSurfaceDataQueryKey = (options: Options<GetMisfitSurfaceDataData_api>) =>
    createQueryKey("getMisfitSurfaceData", options);

/**
 * Get Misfit Surface Data
 */
export const getMisfitSurfaceDataOptions = (options: Options<GetMisfitSurfaceDataData_api>) =>
    queryOptions<
        GetMisfitSurfaceDataResponse_api,
        AxiosError<GetMisfitSurfaceDataError_api>,
        GetMisfitSurfaceDataResponse_api,
        ReturnType<typeof getMisfitSurfaceDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMisfitSurfaceData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getMisfitSurfaceDataQueryKey(options),
    });

export const getParametersAndSensitivitiesQueryKey = (options: Options<GetParametersAndSensitivitiesData_api>) =>
    createQueryKey("getParametersAndSensitivities", options);

/**
 * Get Parameters And Sensitivities
 */
export const getParametersAndSensitivitiesOptions = (options: Options<GetParametersAndSensitivitiesData_api>) =>
    queryOptions<
        GetParametersAndSensitivitiesResponse_api,
        AxiosError<GetParametersAndSensitivitiesError_api>,
        GetParametersAndSensitivitiesResponse_api,
        ReturnType<typeof getParametersAndSensitivitiesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getParametersAndSensitivities({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getParametersAndSensitivitiesQueryKey(options),
    });

export const getGridModelsInfoQueryKey = (options: Options<GetGridModelsInfoData_api>) =>
    createQueryKey("getGridModelsInfo", options);

/**
 * Get Grid Models Info
 *
 * Get metadata for all 3D grid models, including bbox, dimensions and properties
 */
export const getGridModelsInfoOptions = (options: Options<GetGridModelsInfoData_api>) =>
    queryOptions<
        GetGridModelsInfoResponse_api,
        AxiosError<GetGridModelsInfoError_api>,
        GetGridModelsInfoResponse_api,
        ReturnType<typeof getGridModelsInfoQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGridModelsInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getGridModelsInfoQueryKey(options),
    });

export const getGridSurfaceQueryKey = (options: Options<GetGridSurfaceData_api>) =>
    createQueryKey("getGridSurface", options);

/**
 * Get Grid Surface
 *
 * Get a grid
 */
export const getGridSurfaceOptions = (options: Options<GetGridSurfaceData_api>) =>
    queryOptions<
        GetGridSurfaceResponse_api,
        AxiosError<GetGridSurfaceError_api>,
        GetGridSurfaceResponse_api,
        ReturnType<typeof getGridSurfaceQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGridSurface({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getGridSurfaceQueryKey(options),
    });

export const getGridParameterQueryKey = (options: Options<GetGridParameterData_api>) =>
    createQueryKey("getGridParameter", options);

/**
 * Get Grid Parameter
 *
 * Get a grid parameter
 */
export const getGridParameterOptions = (options: Options<GetGridParameterData_api>) =>
    queryOptions<
        GetGridParameterResponse_api,
        AxiosError<GetGridParameterError_api>,
        GetGridParameterResponse_api,
        ReturnType<typeof getGridParameterQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getGridParameter({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getGridParameterQueryKey(options),
    });

export const postGetPolylineIntersectionQueryKey = (options: Options<PostGetPolylineIntersectionData_api>) =>
    createQueryKey("postGetPolylineIntersection", options);

/**
 * Post Get Polyline Intersection
 *
 * Get the intersection of a polyline with the grid, including intersected cells and interpolated parameter values at intersection points
 */
export const postGetPolylineIntersectionOptions = (options: Options<PostGetPolylineIntersectionData_api>) =>
    queryOptions<
        PostGetPolylineIntersectionResponse_api,
        AxiosError<PostGetPolylineIntersectionError_api>,
        PostGetPolylineIntersectionResponse_api,
        ReturnType<typeof postGetPolylineIntersectionQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postGetPolylineIntersection({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: postGetPolylineIntersectionQueryKey(options),
    });

/**
 * Post Get Polyline Intersection
 *
 * Get the intersection of a polyline with the grid, including intersected cells and interpolated parameter values at intersection points
 */
export const postGetPolylineIntersectionMutation = (
    options?: Partial<Options<PostGetPolylineIntersectionData_api>>,
): UseMutationOptions<
    PostGetPolylineIntersectionResponse_api,
    AxiosError<PostGetPolylineIntersectionError_api>,
    Options<PostGetPolylineIntersectionData_api>
> => {
    const mutationOptions: UseMutationOptions<
        PostGetPolylineIntersectionResponse_api,
        AxiosError<PostGetPolylineIntersectionError_api>,
        Options<PostGetPolylineIntersectionData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postGetPolylineIntersection({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getRealizationFlowNetworkQueryKey = (options: Options<GetRealizationFlowNetworkData_api>) =>
    createQueryKey("getRealizationFlowNetwork", options);

/**
 * Get Realization Flow Network
 *
 * Get flow network data for single realization
 */
export const getRealizationFlowNetworkOptions = (options: Options<GetRealizationFlowNetworkData_api>) =>
    queryOptions<
        GetRealizationFlowNetworkResponse_api,
        AxiosError<GetRealizationFlowNetworkError_api>,
        GetRealizationFlowNetworkResponse_api,
        ReturnType<typeof getRealizationFlowNetworkQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRealizationFlowNetwork({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRealizationFlowNetworkQueryKey(options),
    });

export const getProductionDataQueryKey = (options: Options<GetProductionDataData_api>) =>
    createQueryKey("getProductionData", options);

/**
 * Get Production Data
 *
 * Get allocated production per well in the time interval
 */
export const getProductionDataOptions = (options: Options<GetProductionDataData_api>) =>
    queryOptions<
        GetProductionDataResponse_api,
        AxiosError<GetProductionDataError_api>,
        GetProductionDataResponse_api,
        ReturnType<typeof getProductionDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getProductionData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getProductionDataQueryKey(options),
    });

export const getInjectionDataQueryKey = (options: Options<GetInjectionDataData_api>) =>
    createQueryKey("getInjectionData", options);

/**
 * Get Injection Data
 *
 * Get allocated injection per well in the time interval
 */
export const getInjectionDataOptions = (options: Options<GetInjectionDataData_api>) =>
    queryOptions<
        GetInjectionDataResponse_api,
        AxiosError<GetInjectionDataError_api>,
        GetInjectionDataResponse_api,
        ReturnType<typeof getInjectionDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInjectionData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getInjectionDataQueryKey(options),
    });

export const getPvtTableDataQueryKey = (options: Options<GetPvtTableDataData_api>) =>
    createQueryKey("getPvtTableData", options);

/**
 * Get Pvt Table Data
 *
 * Get pvt table data for a given Sumo ensemble and realization
 */
export const getPvtTableDataOptions = (options: Options<GetPvtTableDataData_api>) =>
    queryOptions<
        GetPvtTableDataResponse_api,
        AxiosError<GetPvtTableDataError_api>,
        GetPvtTableDataResponse_api,
        ReturnType<typeof getPvtTableDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPvtTableData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getPvtTableDataQueryKey(options),
    });

export const getWellCompletionsDataQueryKey = (options: Options<GetWellCompletionsDataData_api>) =>
    createQueryKey("getWellCompletionsData", options);

/**
 * Get Well Completions Data
 */
export const getWellCompletionsDataOptions = (options: Options<GetWellCompletionsDataData_api>) =>
    queryOptions<
        GetWellCompletionsDataResponse_api,
        AxiosError<GetWellCompletionsDataError_api>,
        GetWellCompletionsDataResponse_api,
        ReturnType<typeof getWellCompletionsDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellCompletionsData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellCompletionsDataQueryKey(options),
    });

export const getDrilledWellboreHeadersQueryKey = (options: Options<GetDrilledWellboreHeadersData_api>) =>
    createQueryKey("getDrilledWellboreHeaders", options);

/**
 * Get Drilled Wellbore Headers
 *
 * Get wellbore headers for all wells in a given field
 */
export const getDrilledWellboreHeadersOptions = (options: Options<GetDrilledWellboreHeadersData_api>) =>
    queryOptions<
        GetDrilledWellboreHeadersResponse_api,
        AxiosError<GetDrilledWellboreHeadersError_api>,
        GetDrilledWellboreHeadersResponse_api,
        ReturnType<typeof getDrilledWellboreHeadersQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getDrilledWellboreHeaders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getDrilledWellboreHeadersQueryKey(options),
    });

export const getPlannedWellboreHeadersQueryKey = (options: Options<GetPlannedWellboreHeadersData_api>) =>
    createQueryKey("getPlannedWellboreHeaders", options);

/**
 * Get Planned Wellbore Headers
 *
 * Get planned wellbore headers for all planned wells in a given field
 */
export const getPlannedWellboreHeadersOptions = (options: Options<GetPlannedWellboreHeadersData_api>) =>
    queryOptions<
        GetPlannedWellboreHeadersResponse_api,
        AxiosError<GetPlannedWellboreHeadersError_api>,
        GetPlannedWellboreHeadersResponse_api,
        ReturnType<typeof getPlannedWellboreHeadersQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPlannedWellboreHeaders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getPlannedWellboreHeadersQueryKey(options),
    });

export const getFieldPerforationsQueryKey = (options: Options<GetFieldPerforationsData_api>) =>
    createQueryKey("getFieldPerforations", options);

/**
 * Get Field Perforations
 *
 * Get field perforations for all wellbores in a given field.
 */
export const getFieldPerforationsOptions = (options: Options<GetFieldPerforationsData_api>) =>
    queryOptions<
        GetFieldPerforationsResponse_api,
        AxiosError<GetFieldPerforationsError_api>,
        GetFieldPerforationsResponse_api,
        ReturnType<typeof getFieldPerforationsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldPerforations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFieldPerforationsQueryKey(options),
    });

export const getFieldScreensQueryKey = (options: Options<GetFieldScreensData_api>) =>
    createQueryKey("getFieldScreens", options);

/**
 * Get Field Screens
 *
 * Get field screens for all wellbores in a given field.
 * Screens are the SSDL completions with a filter on "Screen" type.
 */
export const getFieldScreensOptions = (options: Options<GetFieldScreensData_api>) =>
    queryOptions<
        GetFieldScreensResponse_api,
        AxiosError<GetFieldScreensError_api>,
        GetFieldScreensResponse_api,
        ReturnType<typeof getFieldScreensQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFieldScreens({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFieldScreensQueryKey(options),
    });

export const getWellTrajectoriesQueryKey = (options: Options<GetWellTrajectoriesData_api>) =>
    createQueryKey("getWellTrajectories", options);

/**
 * Get Well Trajectories
 *
 * Get trajectories for wellbores in a given field. Can optionally return only a subset if a list of uuids are given
 */
export const getWellTrajectoriesOptions = (options: Options<GetWellTrajectoriesData_api>) =>
    queryOptions<
        GetWellTrajectoriesResponse_api,
        AxiosError<GetWellTrajectoriesError_api>,
        GetWellTrajectoriesResponse_api,
        ReturnType<typeof getWellTrajectoriesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellTrajectories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellTrajectoriesQueryKey(options),
    });

export const getPlannedWellTrajectoriesQueryKey = (options: Options<GetPlannedWellTrajectoriesData_api>) =>
    createQueryKey("getPlannedWellTrajectories", options);

/**
 * Get Planned Well Trajectories
 *
 * Get planned trajectories for wellbores in a given field. Can optionally return only a subset if a list of uuids are given
 */
export const getPlannedWellTrajectoriesOptions = (options: Options<GetPlannedWellTrajectoriesData_api>) =>
    queryOptions<
        GetPlannedWellTrajectoriesResponse_api,
        AxiosError<GetPlannedWellTrajectoriesError_api>,
        GetPlannedWellTrajectoriesResponse_api,
        ReturnType<typeof getPlannedWellTrajectoriesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPlannedWellTrajectories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getPlannedWellTrajectoriesQueryKey(options),
    });

export const getWellborePickIdentifiersQueryKey = (options: Options<GetWellborePickIdentifiersData_api>) =>
    createQueryKey("getWellborePickIdentifiers", options);

/**
 * Get Wellbore Pick Identifiers
 *
 * Get wellbore pick identifiers for a given stratigraphic column
 */
export const getWellborePickIdentifiersOptions = (options: Options<GetWellborePickIdentifiersData_api>) =>
    queryOptions<
        GetWellborePickIdentifiersResponse_api,
        AxiosError<GetWellborePickIdentifiersError_api>,
        GetWellborePickIdentifiersResponse_api,
        ReturnType<typeof getWellborePickIdentifiersQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellborePickIdentifiers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellborePickIdentifiersQueryKey(options),
    });

export const getWellborePicksForPickIdentifierQueryKey = (
    options: Options<GetWellborePicksForPickIdentifierData_api>,
) => createQueryKey("getWellborePicksForPickIdentifier", options);

/**
 * Get Wellbore Picks For Pick Identifier
 *
 * Get wellbore picks for a field and pick identifier
 *
 * This implies picks for multiple wellbores for given field and pick identifier.
 * E.g. picks for all wellbores in a given surface in a field.
 */
export const getWellborePicksForPickIdentifierOptions = (options: Options<GetWellborePicksForPickIdentifierData_api>) =>
    queryOptions<
        GetWellborePicksForPickIdentifierResponse_api,
        AxiosError<GetWellborePicksForPickIdentifierError_api>,
        GetWellborePicksForPickIdentifierResponse_api,
        ReturnType<typeof getWellborePicksForPickIdentifierQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellborePicksForPickIdentifier({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellborePicksForPickIdentifierQueryKey(options),
    });

export const getWellborePicksInStratColumnQueryKey = (options: Options<GetWellborePicksInStratColumnData_api>) =>
    createQueryKey("getWellborePicksInStratColumn", options);

/**
 * Get Wellbore Picks In Strat Column
 *
 * Get wellbore picks for a single wellbore within stratigraphic column
 */
export const getWellborePicksInStratColumnOptions = (options: Options<GetWellborePicksInStratColumnData_api>) =>
    queryOptions<
        GetWellborePicksInStratColumnResponse_api,
        AxiosError<GetWellborePicksInStratColumnError_api>,
        GetWellborePicksInStratColumnResponse_api,
        ReturnType<typeof getWellborePicksInStratColumnQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellborePicksInStratColumn({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellborePicksInStratColumnQueryKey(options),
    });

export const getWellboreStratigraphicColumnsQueryKey = (options: Options<GetWellboreStratigraphicColumnsData_api>) =>
    createQueryKey("getWellboreStratigraphicColumns", options);

/**
 * Get Wellbore Stratigraphic Columns
 *
 * Get stratigraphic columns for a given wellbore
 */
export const getWellboreStratigraphicColumnsOptions = (options: Options<GetWellboreStratigraphicColumnsData_api>) =>
    queryOptions<
        GetWellboreStratigraphicColumnsResponse_api,
        AxiosError<GetWellboreStratigraphicColumnsError_api>,
        GetWellboreStratigraphicColumnsResponse_api,
        ReturnType<typeof getWellboreStratigraphicColumnsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellboreStratigraphicColumns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellboreStratigraphicColumnsQueryKey(options),
    });

export const getWellboreCompletionsQueryKey = (options: Options<GetWellboreCompletionsData_api>) =>
    createQueryKey("getWellboreCompletions", options);

/**
 * Get Wellbore Completions
 *
 * Get wellbore completions for a given wellbore
 */
export const getWellboreCompletionsOptions = (options: Options<GetWellboreCompletionsData_api>) =>
    queryOptions<
        GetWellboreCompletionsResponse_api,
        AxiosError<GetWellboreCompletionsError_api>,
        GetWellboreCompletionsResponse_api,
        ReturnType<typeof getWellboreCompletionsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellboreCompletions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellboreCompletionsQueryKey(options),
    });

export const getWellboreCasingsQueryKey = (options: Options<GetWellboreCasingsData_api>) =>
    createQueryKey("getWellboreCasings", options);

/**
 * Get Wellbore Casings
 *
 * Get wellbore casings for a given wellbore
 */
export const getWellboreCasingsOptions = (options: Options<GetWellboreCasingsData_api>) =>
    queryOptions<
        GetWellboreCasingsResponse_api,
        AxiosError<GetWellboreCasingsError_api>,
        GetWellboreCasingsResponse_api,
        ReturnType<typeof getWellboreCasingsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellboreCasings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellboreCasingsQueryKey(options),
    });

export const getWellborePerforationsQueryKey = (options: Options<GetWellborePerforationsData_api>) =>
    createQueryKey("getWellborePerforations", options);

/**
 * Get Wellbore Perforations
 *
 * Get wellbore perforations for a given wellbore
 */
export const getWellborePerforationsOptions = (options: Options<GetWellborePerforationsData_api>) =>
    queryOptions<
        GetWellborePerforationsResponse_api,
        AxiosError<GetWellborePerforationsError_api>,
        GetWellborePerforationsResponse_api,
        ReturnType<typeof getWellborePerforationsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellborePerforations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellborePerforationsQueryKey(options),
    });

export const getWellboreLogCurveHeadersQueryKey = (options: Options<GetWellboreLogCurveHeadersData_api>) =>
    createQueryKey("getWellboreLogCurveHeaders", options);

/**
 * Get Wellbore Log Curve Headers
 *
 * Get all log curve headers for a single well bore.
 * Logs are available from multiple sources, which can be specificed by the "sources" parameter.
 */
export const getWellboreLogCurveHeadersOptions = (options: Options<GetWellboreLogCurveHeadersData_api>) =>
    queryOptions<
        GetWellboreLogCurveHeadersResponse_api,
        AxiosError<GetWellboreLogCurveHeadersError_api>,
        GetWellboreLogCurveHeadersResponse_api,
        ReturnType<typeof getWellboreLogCurveHeadersQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellboreLogCurveHeaders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getWellboreLogCurveHeadersQueryKey(options),
    });

export const getLogCurveDataQueryKey = (options: Options<GetLogCurveDataData_api>) =>
    createQueryKey("getLogCurveData", options);

/**
 * Get Log Curve Data
 *
 * Get log curve data
 */
export const getLogCurveDataOptions = (options: Options<GetLogCurveDataData_api>) =>
    queryOptions<
        GetLogCurveDataResponse_api,
        AxiosError<GetLogCurveDataError_api>,
        GetLogCurveDataResponse_api,
        ReturnType<typeof getLogCurveDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLogCurveData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getLogCurveDataQueryKey(options),
    });

export const getSeismicCubeMetaListQueryKey = (options: Options<GetSeismicCubeMetaListData_api>) =>
    createQueryKey("getSeismicCubeMetaList", options);

/**
 * Get Seismic Cube Meta List
 *
 * Get a list of seismic cube meta.
 */
export const getSeismicCubeMetaListOptions = (options: Options<GetSeismicCubeMetaListData_api>) =>
    queryOptions<
        GetSeismicCubeMetaListResponse_api,
        AxiosError<GetSeismicCubeMetaListError_api>,
        GetSeismicCubeMetaListResponse_api,
        ReturnType<typeof getSeismicCubeMetaListQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSeismicCubeMetaList({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSeismicCubeMetaListQueryKey(options),
    });

export const getSeismicSlicesQueryKey = (options: Options<GetSeismicSlicesData_api>) =>
    createQueryKey("getSeismicSlices", options);

/**
 * Get Seismic Slices
 *
 * Get a seismic depth slice from a seismic cube.
 */
export const getSeismicSlicesOptions = (options: Options<GetSeismicSlicesData_api>) =>
    queryOptions<
        GetSeismicSlicesResponse_api,
        AxiosError<GetSeismicSlicesError_api>,
        GetSeismicSlicesResponse_api,
        ReturnType<typeof getSeismicSlicesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSeismicSlices({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSeismicSlicesQueryKey(options),
    });

export const postGetSeismicFenceQueryKey = (options: Options<PostGetSeismicFenceData_api>) =>
    createQueryKey("postGetSeismicFence", options);

/**
 * Post Get Seismic Fence
 *
 * Get a fence of seismic data from a polyline defined by a set of (x, y) coordinates in domain coordinate system.
 *
 * The fence data contains a set of traces perpendicular to the polyline, with one trace per (x, y)-point in polyline.
 * Each trace has equal number of samples, and is a set of sample values along the depth direction of the seismic cube.
 *
 * Returns:
 * A SeismicFenceData object with fence traces in encoded 1D array, metadata for trace array decoding and fence min/max depth.
 */
export const postGetSeismicFenceOptions = (options: Options<PostGetSeismicFenceData_api>) =>
    queryOptions<
        PostGetSeismicFenceResponse_api,
        AxiosError<PostGetSeismicFenceError_api>,
        PostGetSeismicFenceResponse_api,
        ReturnType<typeof postGetSeismicFenceQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postGetSeismicFence({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: postGetSeismicFenceQueryKey(options),
    });

/**
 * Post Get Seismic Fence
 *
 * Get a fence of seismic data from a polyline defined by a set of (x, y) coordinates in domain coordinate system.
 *
 * The fence data contains a set of traces perpendicular to the polyline, with one trace per (x, y)-point in polyline.
 * Each trace has equal number of samples, and is a set of sample values along the depth direction of the seismic cube.
 *
 * Returns:
 * A SeismicFenceData object with fence traces in encoded 1D array, metadata for trace array decoding and fence min/max depth.
 */
export const postGetSeismicFenceMutation = (
    options?: Partial<Options<PostGetSeismicFenceData_api>>,
): UseMutationOptions<
    PostGetSeismicFenceResponse_api,
    AxiosError<PostGetSeismicFenceError_api>,
    Options<PostGetSeismicFenceData_api>
> => {
    const mutationOptions: UseMutationOptions<
        PostGetSeismicFenceResponse_api,
        AxiosError<PostGetSeismicFenceError_api>,
        Options<PostGetSeismicFenceData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postGetSeismicFence({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getPolygonsDirectoryQueryKey = (options: Options<GetPolygonsDirectoryData_api>) =>
    createQueryKey("getPolygonsDirectory", options);

/**
 * Get Polygons Directory
 *
 * Get a directory of polygons in a Sumo ensemble
 */
export const getPolygonsDirectoryOptions = (options: Options<GetPolygonsDirectoryData_api>) =>
    queryOptions<
        GetPolygonsDirectoryResponse_api,
        AxiosError<GetPolygonsDirectoryError_api>,
        GetPolygonsDirectoryResponse_api,
        ReturnType<typeof getPolygonsDirectoryQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPolygonsDirectory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getPolygonsDirectoryQueryKey(options),
    });

export const getPolygonsDataQueryKey = (options: Options<GetPolygonsDataData_api>) =>
    createQueryKey("getPolygonsData", options);

/**
 * Get Polygons Data
 */
export const getPolygonsDataOptions = (options: Options<GetPolygonsDataData_api>) =>
    queryOptions<
        GetPolygonsDataResponse_api,
        AxiosError<GetPolygonsDataError_api>,
        GetPolygonsDataResponse_api,
        ReturnType<typeof getPolygonsDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPolygonsData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getPolygonsDataQueryKey(options),
    });

export const getUserInfoQueryKey = (options: Options<GetUserInfoData_api>) => createQueryKey("getUserInfo", options);

/**
 * Get User Info
 */
export const getUserInfoOptions = (options: Options<GetUserInfoData_api>) =>
    queryOptions<
        GetUserInfoResponse_api,
        AxiosError<GetUserInfoError_api>,
        GetUserInfoResponse_api,
        ReturnType<typeof getUserInfoQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getUserInfoQueryKey(options),
    });

export const getUserPhotoQueryKey = (options: Options<GetUserPhotoData_api>) => createQueryKey("getUserPhoto", options);

/**
 * Get User Photo
 *
 * Get username, display name and avatar from Microsoft Graph API for a given user email or graph identity
 */
export const getUserPhotoOptions = (options: Options<GetUserPhotoData_api>) =>
    queryOptions<
        GetUserPhotoResponse_api,
        AxiosError<GetUserPhotoError_api>,
        GetUserPhotoResponse_api,
        ReturnType<typeof getUserPhotoQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserPhoto({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getUserPhotoQueryKey(options),
    });

export const getSummaryObservationsQueryKey = (options: Options<GetSummaryObservationsData_api>) =>
    createQueryKey("getSummaryObservations", options);

/**
 * Get Summary Observations
 *
 * Retrieve all summary observations found in ensemble
 */
export const getSummaryObservationsOptions = (options: Options<GetSummaryObservationsData_api>) =>
    queryOptions<
        GetSummaryObservationsResponse_api,
        AxiosError<GetSummaryObservationsError_api>,
        GetSummaryObservationsResponse_api,
        ReturnType<typeof getSummaryObservationsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSummaryObservations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSummaryObservationsQueryKey(options),
    });

export const getRelpermTableNamesQueryKey = (options: Options<GetRelpermTableNamesData_api>) =>
    createQueryKey("getRelpermTableNames", options);

/**
 * Get Relperm Table Names
 */
export const getRelpermTableNamesOptions = (options: Options<GetRelpermTableNamesData_api>) =>
    queryOptions<
        GetRelpermTableNamesResponse_api,
        AxiosError<GetRelpermTableNamesError_api>,
        GetRelpermTableNamesResponse_api,
        ReturnType<typeof getRelpermTableNamesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRelpermTableNames({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRelpermTableNamesQueryKey(options),
    });

export const getRelpermTableDefinitionQueryKey = (options: Options<GetRelpermTableDefinitionData_api>) =>
    createQueryKey("getRelpermTableDefinition", options);

/**
 * Get Relperm Table Definition
 */
export const getRelpermTableDefinitionOptions = (options: Options<GetRelpermTableDefinitionData_api>) =>
    queryOptions<
        GetRelpermTableDefinitionResponse_api,
        AxiosError<GetRelpermTableDefinitionError_api>,
        GetRelpermTableDefinitionResponse_api,
        ReturnType<typeof getRelpermTableDefinitionQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRelpermTableDefinition({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRelpermTableDefinitionQueryKey(options),
    });

export const getRelpermRealizationDataQueryKey = (options: Options<GetRelpermRealizationDataData_api>) =>
    createQueryKey("getRelpermRealizationData", options);

/**
 * Get Relperm Realization Data
 */
export const getRelpermRealizationDataOptions = (options: Options<GetRelpermRealizationDataData_api>) =>
    queryOptions<
        GetRelpermRealizationDataResponse_api,
        AxiosError<GetRelpermRealizationDataError_api>,
        GetRelpermRealizationDataResponse_api,
        ReturnType<typeof getRelpermRealizationDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRelpermRealizationData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRelpermRealizationDataQueryKey(options),
    });

export const getRftTableDefinitionQueryKey = (options: Options<GetRftTableDefinitionData_api>) =>
    createQueryKey("getRftTableDefinition", options);

/**
 * Get Rft Table Definition
 *
 * Get the RFT table definition for a given ensemble.
 */
export const getRftTableDefinitionOptions = (options: Options<GetRftTableDefinitionData_api>) =>
    queryOptions<
        GetRftTableDefinitionResponse_api,
        AxiosError<GetRftTableDefinitionError_api>,
        GetRftTableDefinitionResponse_api,
        ReturnType<typeof getRftTableDefinitionQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRftTableDefinition({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRftTableDefinitionQueryKey(options),
    });

export const getRftRealizationDataQueryKey = (options: Options<GetRftRealizationDataData_api>) =>
    createQueryKey("getRftRealizationData", options);

/**
 * Get Rft Realization Data
 *
 * Get a list of RFT data per realization, for a given well and response.
 */
export const getRftRealizationDataOptions = (options: Options<GetRftRealizationDataData_api>) =>
    queryOptions<
        GetRftRealizationDataResponse_api,
        AxiosError<GetRftRealizationDataError_api>,
        GetRftRealizationDataResponse_api,
        ReturnType<typeof getRftRealizationDataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRftRealizationData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRftRealizationDataQueryKey(options),
    });

export const getRftObservationsQueryKey = (options: Options<GetRftObservationsData_api>) =>
    createQueryKey("getRftObservations", options);

/**
 * Get Rft Observations
 *
 * Get RFT observations per well and date for a given ensemble.
 */
export const getRftObservationsOptions = (options: Options<GetRftObservationsData_api>) =>
    queryOptions<
        GetRftObservationsResponse_api,
        AxiosError<GetRftObservationsError_api>,
        GetRftObservationsResponse_api,
        ReturnType<typeof getRftObservationsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRftObservations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRftObservationsQueryKey(options),
    });

export const getVfpTablesQueryKey = (options: Options<GetVfpTablesData_api>) => createQueryKey("getVfpTables", options);

/**
 * Get Vfp Tables
 *
 * Get the available VFP tables (type and number) for a given ensemble and realization.
 */
export const getVfpTablesOptions = (options: Options<GetVfpTablesData_api>) =>
    queryOptions<
        GetVfpTablesResponse_api,
        AxiosError<GetVfpTablesError_api>,
        GetVfpTablesResponse_api,
        ReturnType<typeof getVfpTablesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getVfpTables({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getVfpTablesQueryKey(options),
    });

export const getVfpTableQueryKey = (options: Options<GetVfpTableData_api>) => createQueryKey("getVfpTable", options);

/**
 * Get Vfp Table
 *
 * Get the VFP table for a given ensemble, realization, type and table number.
 */
export const getVfpTableOptions = (options: Options<GetVfpTableData_api>) =>
    queryOptions<
        GetVfpTableResponse_api,
        AxiosError<GetVfpTableError_api>,
        GetVfpTableResponse_api,
        ReturnType<typeof getVfpTableQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getVfpTable({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getVfpTableQueryKey(options),
    });

export const getSessionsMetadataQueryKey = (options?: Options<GetSessionsMetadataData_api>) =>
    createQueryKey("getSessionsMetadata", options);

/**
 * Get Sessions Metadata
 *
 * Get a paginated list of session metadata for the authenticated user.
 *
 * This endpoint returns session metadata (without content) with support for:
 * - **Pagination**: Use the continuation token to fetch subsequent pages
 * - **Sorting**: Sort by various fields in ascending or descending order
 * - **Case-insensitive sorting**: Optional lowercase sorting for text fields
 * - **Filtering**: Filter by title and date ranges
 *
 * The response includes a continuation token for fetching the next page of results.
 */
export const getSessionsMetadataOptions = (options?: Options<GetSessionsMetadataData_api>) =>
    queryOptions<
        GetSessionsMetadataResponse_api,
        AxiosError<GetSessionsMetadataError_api>,
        GetSessionsMetadataResponse_api,
        ReturnType<typeof getSessionsMetadataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSessionsMetadata({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSessionsMetadataQueryKey(options),
    });

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], "body" | "headers" | "path" | "query">>(
    queryKey: QueryKey<Options>,
    page: K,
) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...(queryKey[0].body as any),
            ...(page.body as any),
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers,
        };
    }
    if (page.path) {
        params.path = {
            ...(queryKey[0].path as any),
            ...(page.path as any),
        };
    }
    if (page.query) {
        params.query = {
            ...(queryKey[0].query as any),
            ...(page.query as any),
        };
    }
    return params as unknown as typeof page;
};

export const getSessionsMetadataInfiniteQueryKey = (
    options?: Options<GetSessionsMetadataData_api>,
): QueryKey<Options<GetSessionsMetadataData_api>> => createQueryKey("getSessionsMetadata", options, true);

/**
 * Get Sessions Metadata
 *
 * Get a paginated list of session metadata for the authenticated user.
 *
 * This endpoint returns session metadata (without content) with support for:
 * - **Pagination**: Use the continuation token to fetch subsequent pages
 * - **Sorting**: Sort by various fields in ascending or descending order
 * - **Case-insensitive sorting**: Optional lowercase sorting for text fields
 * - **Filtering**: Filter by title and date ranges
 *
 * The response includes a continuation token for fetching the next page of results.
 */
export const getSessionsMetadataInfiniteOptions = (options?: Options<GetSessionsMetadataData_api>) => {
    const opts = infiniteQueryOptions<
        GetSessionsMetadataResponse_api,
        AxiosError<GetSessionsMetadataError_api>,
        InfiniteData<GetSessionsMetadataResponse_api>,
        QueryKey<Options<GetSessionsMetadataData_api>>,
        string | null | Pick<QueryKey<Options<GetSessionsMetadataData_api>>[0], "body" | "headers" | "path" | "query">
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<
                    QueryKey<Options<GetSessionsMetadataData_api>>[0],
                    "body" | "headers" | "path" | "query"
                > =
                    typeof pageParam === "object"
                        ? pageParam
                        : {
                              query: {
                                  cursor: pageParam,
                              },
                          };
                const params = createInfiniteParams(queryKey, page);
                const { data } = await getSessionsMetadata({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                });
                return data;
            },
            queryKey: getSessionsMetadataInfiniteQueryKey(options),
        },
    );
    return opts as Omit<typeof opts, "initialData">;
};

export const createSessionQueryKey = (options: Options<CreateSessionData_api>) =>
    createQueryKey("createSession", options);

/**
 * Create Session
 *
 * Create a new session for the authenticated user.
 *
 * Provide:
 * - **title**: Session title (required)
 * - **description**: Optional description
 * - **content**: Session content (required)
 *
 * The system automatically generates:
 * - Unique session ID
 * - Creation and update timestamps
 * - Version number (starts at 1)
 * - Content hash for integrity checking
 *
 * Returns the ID of the newly created session.
 */
export const createSessionOptions = (options: Options<CreateSessionData_api>) =>
    queryOptions<
        CreateSessionResponse_api,
        AxiosError<CreateSessionError_api>,
        CreateSessionResponse_api,
        ReturnType<typeof createSessionQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createSession({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: createSessionQueryKey(options),
    });

/**
 * Create Session
 *
 * Create a new session for the authenticated user.
 *
 * Provide:
 * - **title**: Session title (required)
 * - **description**: Optional description
 * - **content**: Session content (required)
 *
 * The system automatically generates:
 * - Unique session ID
 * - Creation and update timestamps
 * - Version number (starts at 1)
 * - Content hash for integrity checking
 *
 * Returns the ID of the newly created session.
 */
export const createSessionMutation = (
    options?: Partial<Options<CreateSessionData_api>>,
): UseMutationOptions<
    CreateSessionResponse_api,
    AxiosError<CreateSessionError_api>,
    Options<CreateSessionData_api>
> => {
    const mutationOptions: UseMutationOptions<
        CreateSessionResponse_api,
        AxiosError<CreateSessionError_api>,
        Options<CreateSessionData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

/**
 * Delete Session
 *
 * Permanently delete a session.
 *
 * This operation:
 * - Removes the session document from the database
 * - Cannot be undone
 * - Requires ownership verification
 *
 * Only the session owner can delete their sessions.
 */
export const deleteSessionMutation = (
    options?: Partial<Options<DeleteSessionData_api>>,
): UseMutationOptions<unknown, AxiosError<DeleteSessionError_api>, Options<DeleteSessionData_api>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<DeleteSessionError_api>,
        Options<DeleteSessionData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getSessionQueryKey = (options: Options<GetSessionData_api>) => createQueryKey("getSession", options);

/**
 * Get Session
 *
 * Retrieve a complete session by its ID.
 *
 * Returns the full session document including:
 * - Session metadata (title, description, timestamps, version, etc.)
 * - Complete session content
 *
 * Only the session owner can access this endpoint.
 */
export const getSessionOptions = (options: Options<GetSessionData_api>) =>
    queryOptions<
        GetSessionResponse_api,
        AxiosError<GetSessionError_api>,
        GetSessionResponse_api,
        ReturnType<typeof getSessionQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSession({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSessionQueryKey(options),
    });

/**
 * Update Session
 *
 * Update an existing session with partial or complete changes.
 *
 * You can update any combination of:
 * - **title**: New session title
 * - **description**: New description
 * - **content**: New session content
 *
 * All fields are optional - only provided fields will be updated.
 *
 * The system automatically:
 * - Updates the `updated_at` timestamp
 * - Increments the version number
 * - Recalculates the content hash if content changed
 * - Preserves ownership and creation metadata
 *
 * Returns the complete updated session.
 *
 * Only the session owner can update their sessions.
 */
export const updateSessionMutation = (
    options?: Partial<Options<UpdateSessionData_api>>,
): UseMutationOptions<
    UpdateSessionResponse_api,
    AxiosError<UpdateSessionError_api>,
    Options<UpdateSessionData_api>
> => {
    const mutationOptions: UseMutationOptions<
        UpdateSessionResponse_api,
        AxiosError<UpdateSessionError_api>,
        Options<UpdateSessionData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getSessionMetadataQueryKey = (options: Options<GetSessionMetadataData_api>) =>
    createQueryKey("getSessionMetadata", options);

/**
 * Get Session Metadata
 *
 * Retrieve only the metadata for a specific session.
 *
 * Returns session metadata without the content, useful for:
 * - Listing sessions with details
 * - Checking version or timestamps
 * - Lightweight operations that don't need full content
 *
 * Only the session owner can access this endpoint.
 */
export const getSessionMetadataOptions = (options: Options<GetSessionMetadataData_api>) =>
    queryOptions<
        GetSessionMetadataResponse_api,
        AxiosError<GetSessionMetadataError_api>,
        GetSessionMetadataResponse_api,
        ReturnType<typeof getSessionMetadataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSessionMetadata({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSessionMetadataQueryKey(options),
    });

export const getSnapshotAccessLogsQueryKey = (options?: Options<GetSnapshotAccessLogsData_api>) =>
    createQueryKey("getSnapshotAccessLogs", options);

/**
 * Get Snapshot Access Logs
 *
 * Get a list of all snapshots you have visited.
 *
 * This endpoint tracks your interaction history with snapshots, including:
 * - Snapshots you've created (counted as implicit visits)
 * - Snapshots you've viewed
 * - Snapshots shared with you that you've accessed
 *
 * Each access log entry includes:
 * - **Visit count**: Number of times you've viewed the snapshot
 * - **First visited**: Timestamp of your first visit
 * - **Last visited**: Timestamp of your most recent visit
 * - **Snapshot metadata**: Title, description, creation date
 * - **Deletion status**: Whether the snapshot has been deleted
 *
 * Supports pagination, sorting, and filtering by:
 * - Title (case insensitive)
 * - Creation date range
 * - Last visited date range
 */
export const getSnapshotAccessLogsOptions = (options?: Options<GetSnapshotAccessLogsData_api>) =>
    queryOptions<
        GetSnapshotAccessLogsResponse_api,
        AxiosError<GetSnapshotAccessLogsError_api>,
        GetSnapshotAccessLogsResponse_api,
        ReturnType<typeof getSnapshotAccessLogsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSnapshotAccessLogs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSnapshotAccessLogsQueryKey(options),
    });

export const getSnapshotAccessLogsInfiniteQueryKey = (
    options?: Options<GetSnapshotAccessLogsData_api>,
): QueryKey<Options<GetSnapshotAccessLogsData_api>> => createQueryKey("getSnapshotAccessLogs", options, true);

/**
 * Get Snapshot Access Logs
 *
 * Get a list of all snapshots you have visited.
 *
 * This endpoint tracks your interaction history with snapshots, including:
 * - Snapshots you've created (counted as implicit visits)
 * - Snapshots you've viewed
 * - Snapshots shared with you that you've accessed
 *
 * Each access log entry includes:
 * - **Visit count**: Number of times you've viewed the snapshot
 * - **First visited**: Timestamp of your first visit
 * - **Last visited**: Timestamp of your most recent visit
 * - **Snapshot metadata**: Title, description, creation date
 * - **Deletion status**: Whether the snapshot has been deleted
 *
 * Supports pagination, sorting, and filtering by:
 * - Title (case insensitive)
 * - Creation date range
 * - Last visited date range
 */
export const getSnapshotAccessLogsInfiniteOptions = (options?: Options<GetSnapshotAccessLogsData_api>) => {
    const opts = infiniteQueryOptions<
        GetSnapshotAccessLogsResponse_api,
        AxiosError<GetSnapshotAccessLogsError_api>,
        InfiniteData<GetSnapshotAccessLogsResponse_api>,
        QueryKey<Options<GetSnapshotAccessLogsData_api>>,
        string | null | Pick<QueryKey<Options<GetSnapshotAccessLogsData_api>>[0], "body" | "headers" | "path" | "query">
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<
                    QueryKey<Options<GetSnapshotAccessLogsData_api>>[0],
                    "body" | "headers" | "path" | "query"
                > =
                    typeof pageParam === "object"
                        ? pageParam
                        : {
                              query: {
                                  cursor: pageParam,
                              },
                          };
                const params = createInfiniteParams(queryKey, page);
                const { data } = await getSnapshotAccessLogs({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                });
                return data;
            },
            queryKey: getSnapshotAccessLogsInfiniteQueryKey(options),
        },
    );
    return opts as Omit<typeof opts, "initialData">;
};

export const getSnapshotsMetadataQueryKey = (options?: Options<GetSnapshotsMetadataData_api>) =>
    createQueryKey("getSnapshotsMetadata", options);

/**
 * Get Snapshots Metadata
 *
 * Get a paginated list of your snapshot metadata.
 *
 * Returns metadata for snapshots you own (without content) with support for:
 * - **Pagination**: Use continuation tokens for large result sets
 * - **Sorting**: Sort by title, creation date, etc.
 * - **Filtering**: Filter by title and date ranges
 *
 * Snapshots are immutable records that can be shared with others.
 * They are separate from sessions and are intended for point-in-time captures.
 *
 * Note: Consider using `/persistence/snapshot_access_logs` to see both your snapshots and ones shared with you.
 */
export const getSnapshotsMetadataOptions = (options?: Options<GetSnapshotsMetadataData_api>) =>
    queryOptions<
        GetSnapshotsMetadataResponse_api,
        AxiosError<GetSnapshotsMetadataError_api>,
        GetSnapshotsMetadataResponse_api,
        ReturnType<typeof getSnapshotsMetadataQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSnapshotsMetadata({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSnapshotsMetadataQueryKey(options),
    });

export const getSnapshotsMetadataInfiniteQueryKey = (
    options?: Options<GetSnapshotsMetadataData_api>,
): QueryKey<Options<GetSnapshotsMetadataData_api>> => createQueryKey("getSnapshotsMetadata", options, true);

/**
 * Get Snapshots Metadata
 *
 * Get a paginated list of your snapshot metadata.
 *
 * Returns metadata for snapshots you own (without content) with support for:
 * - **Pagination**: Use continuation tokens for large result sets
 * - **Sorting**: Sort by title, creation date, etc.
 * - **Filtering**: Filter by title and date ranges
 *
 * Snapshots are immutable records that can be shared with others.
 * They are separate from sessions and are intended for point-in-time captures.
 *
 * Note: Consider using `/persistence/snapshot_access_logs` to see both your snapshots and ones shared with you.
 */
export const getSnapshotsMetadataInfiniteOptions = (options?: Options<GetSnapshotsMetadataData_api>) => {
    const opts = infiniteQueryOptions<
        GetSnapshotsMetadataResponse_api,
        AxiosError<GetSnapshotsMetadataError_api>,
        InfiniteData<GetSnapshotsMetadataResponse_api>,
        QueryKey<Options<GetSnapshotsMetadataData_api>>,
        string | null | Pick<QueryKey<Options<GetSnapshotsMetadataData_api>>[0], "body" | "headers" | "path" | "query">
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<
                    QueryKey<Options<GetSnapshotsMetadataData_api>>[0],
                    "body" | "headers" | "path" | "query"
                > =
                    typeof pageParam === "object"
                        ? pageParam
                        : {
                              query: {
                                  cursor: pageParam,
                              },
                          };
                const params = createInfiniteParams(queryKey, page);
                const { data } = await getSnapshotsMetadata({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                });
                return data;
            },
            queryKey: getSnapshotsMetadataInfiniteQueryKey(options),
        },
    );
    return opts as Omit<typeof opts, "initialData">;
};

export const createSnapshotQueryKey = (options: Options<CreateSnapshotData_api>) =>
    createQueryKey("createSnapshot", options);

/**
 * Create Snapshot
 *
 * Create a new snapshot for point-in-time capture.
 *
 * Provide:
 * - **title**: Snapshot title (required)
 * - **description**: Optional description
 * - **content**: Snapshot content (required)
 *
 * The system automatically:
 * - Generates a unique snapshot ID
 * - Records creation timestamp
 * - Calculates content hash for integrity
 * - **Logs an implicit visit** (so it appears in your visited snapshots)
 *
 * Snapshots are immutable and can be shared with others via their ID.
 *
 * Returns the ID of the newly created snapshot.
 */
export const createSnapshotOptions = (options: Options<CreateSnapshotData_api>) =>
    queryOptions<
        CreateSnapshotResponse_api,
        AxiosError<CreateSnapshotError_api>,
        CreateSnapshotResponse_api,
        ReturnType<typeof createSnapshotQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createSnapshot({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: createSnapshotQueryKey(options),
    });

/**
 * Create Snapshot
 *
 * Create a new snapshot for point-in-time capture.
 *
 * Provide:
 * - **title**: Snapshot title (required)
 * - **description**: Optional description
 * - **content**: Snapshot content (required)
 *
 * The system automatically:
 * - Generates a unique snapshot ID
 * - Records creation timestamp
 * - Calculates content hash for integrity
 * - **Logs an implicit visit** (so it appears in your visited snapshots)
 *
 * Snapshots are immutable and can be shared with others via their ID.
 *
 * Returns the ID of the newly created snapshot.
 */
export const createSnapshotMutation = (
    options?: Partial<Options<CreateSnapshotData_api>>,
): UseMutationOptions<
    CreateSnapshotResponse_api,
    AxiosError<CreateSnapshotError_api>,
    Options<CreateSnapshotData_api>
> => {
    const mutationOptions: UseMutationOptions<
        CreateSnapshotResponse_api,
        AxiosError<CreateSnapshotError_api>,
        Options<CreateSnapshotData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await createSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

/**
 * Delete Snapshot
 *
 * Permanently delete a snapshot.
 *
 * This operation:
 * - Removes the snapshot document from the database
 * - Marks all access logs as deleted (background task)
 * - Cannot be undone
 * - Requires ownership verification
 *
 * **Background Processing:**
 * Access logs are marked as deleted asynchronously to avoid blocking the response.
 * This typically completes within seconds for snapshots with <150 visitor logs.
 *
 * Only the snapshot owner can delete their snapshots.
 */
export const deleteSnapshotMutation = (
    options?: Partial<Options<DeleteSnapshotData_api>>,
): UseMutationOptions<unknown, AxiosError<DeleteSnapshotError_api>, Options<DeleteSnapshotData_api>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<DeleteSnapshotError_api>,
        Options<DeleteSnapshotData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getSnapshotQueryKey = (options: Options<GetSnapshotData_api>) => createQueryKey("getSnapshot", options);

/**
 * Get Snapshot
 *
 * Retrieve a complete snapshot by its ID.
 *
 * Returns the full snapshot document including:
 * - Snapshot metadata (title, description, creation date, etc.)
 * - Complete snapshot content
 *
 * **Important**: This endpoint automatically tracks your visit:
 * - Increments the visit counter
 * - Updates the "last visited" timestamp
 * - Creates an access log entry if this is your first visit
 *
 * This allows you to see your viewing history in `/persistence/snapshot_access_logs`.
 *
 * Any user with the snapshot ID can access snapshots (they are shareable).
 */
export const getSnapshotOptions = (options: Options<GetSnapshotData_api>) =>
    queryOptions<
        GetSnapshotResponse_api,
        AxiosError<GetSnapshotError_api>,
        GetSnapshotResponse_api,
        ReturnType<typeof getSnapshotQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSnapshot({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSnapshotQueryKey(options),
    });

/**
 * Delete Snapshot Access Log
 *
 * Delete your access log for a specific snapshot.
 *
 * This operation:
 * - Removes your access log entry for the given snapshot
 * - Does NOT affect the snapshot itself or other users' logs
 *
 * Use this endpoint to clear your visit history for a snapshot
 * without deleting the snapshot or impacting other users.
 */
export const deleteSnapshotAccessLogMutation = (
    options?: Partial<Options<DeleteSnapshotAccessLogData_api>>,
): UseMutationOptions<
    unknown,
    AxiosError<DeleteSnapshotAccessLogError_api>,
    Options<DeleteSnapshotAccessLogData_api>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<DeleteSnapshotAccessLogError_api>,
        Options<DeleteSnapshotAccessLogData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSnapshotAccessLog({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getMediaSasTokenQueryKey = (options?: Options<GetMediaSasTokenData_api>) =>
    createQueryKey("getMediaSasToken", options);

/**
 * Get Media Sas Token
 *
 * Return a short-lived, read-only container SAS token for fetching tutorial media.
 */
export const getMediaSasTokenOptions = (options?: Options<GetMediaSasTokenData_api>) =>
    queryOptions<
        GetMediaSasTokenResponse_api,
        AxiosError<DefaultError>,
        GetMediaSasTokenResponse_api,
        ReturnType<typeof getMediaSasTokenQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMediaSasToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getMediaSasTokenQueryKey(options),
    });

export const loginRouteQueryKey = (options?: Options<LoginRouteData_api>) => createQueryKey("loginRoute", options);

/**
 *  Login Route
 */
export const loginRouteOptions = (options?: Options<LoginRouteData_api>) =>
    queryOptions<unknown, AxiosError<LoginRouteError_api>, unknown, ReturnType<typeof loginRouteQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await loginRoute({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: loginRouteQueryKey(options),
    });

export const authorizedCallbackRouteQueryKey = (options?: Options<AuthorizedCallbackRouteData_api>) =>
    createQueryKey("authorizedCallbackRoute", options);

/**
 *  Authorized Callback Route
 */
export const authorizedCallbackRouteOptions = (options?: Options<AuthorizedCallbackRouteData_api>) =>
    queryOptions<unknown, AxiosError<DefaultError>, unknown, ReturnType<typeof authorizedCallbackRouteQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await authorizedCallbackRoute({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: authorizedCallbackRouteQueryKey(options),
    });

export const getAliveQueryKey = (options?: Options<GetAliveData_api>) => createQueryKey("getAlive", options);

/**
 * Get Alive
 */
export const getAliveOptions = (options?: Options<GetAliveData_api>) =>
    queryOptions<
        GetAliveResponse_api,
        AxiosError<DefaultError>,
        GetAliveResponse_api,
        ReturnType<typeof getAliveQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAlive({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getAliveQueryKey(options),
    });

export const getAliveProtectedQueryKey = (options?: Options<GetAliveProtectedData_api>) =>
    createQueryKey("getAliveProtected", options);

/**
 * Get Alive Protected
 */
export const getAliveProtectedOptions = (options?: Options<GetAliveProtectedData_api>) =>
    queryOptions<
        GetAliveProtectedResponse_api,
        AxiosError<DefaultError>,
        GetAliveProtectedResponse_api,
        ReturnType<typeof getAliveProtectedQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAliveProtected({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getAliveProtectedQueryKey(options),
    });

export const postLogoutQueryKey = (options?: Options<PostLogoutData_api>) => createQueryKey("postLogout", options);

/**
 * Post Logout
 */
export const postLogoutOptions = (options?: Options<PostLogoutData_api>) =>
    queryOptions<
        PostLogoutResponse_api,
        AxiosError<DefaultError>,
        PostLogoutResponse_api,
        ReturnType<typeof postLogoutQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await postLogout({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: postLogoutQueryKey(options),
    });

/**
 * Post Logout
 */
export const postLogoutMutation = (
    options?: Partial<Options<PostLogoutData_api>>,
): UseMutationOptions<PostLogoutResponse_api, AxiosError<DefaultError>, Options<PostLogoutData_api>> => {
    const mutationOptions: UseMutationOptions<
        PostLogoutResponse_api,
        AxiosError<DefaultError>,
        Options<PostLogoutData_api>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postLogout({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getLoggedInUserQueryKey = (options?: Options<GetLoggedInUserData_api>) =>
    createQueryKey("getLoggedInUser", options);

/**
 * Get Logged In User
 */
export const getLoggedInUserOptions = (options?: Options<GetLoggedInUserData_api>) =>
    queryOptions<
        GetLoggedInUserResponse_api,
        AxiosError<GetLoggedInUserError_api>,
        GetLoggedInUserResponse_api,
        ReturnType<typeof getLoggedInUserQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLoggedInUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getLoggedInUserQueryKey(options),
    });

export const rootQueryKey = (options?: Options<RootData_api>) => createQueryKey("root", options);

/**
 * Root
 */
export const rootOptions = (options?: Options<RootData_api>) =>
    queryOptions<RootResponse_api, AxiosError<DefaultError>, RootResponse_api, ReturnType<typeof rootQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await root({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: rootQueryKey(options),
    });
